module.exports = __webpack_public_path__ + "img/kefu.e0100583.png";